import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export interface ExcelExportOptions {
  /** Índices das colunas (0-based, na linha de dados) que devem ser numéricas */
  numericColumnIndexes?: number[];
  sheetName?: string;
}

/**
 * Exporta para Excel (.xlsx) real.
 */
export function downloadTableAsExcel(
  fileName: string,
  headers: string[],
  rows: (string | number)[][],
  metaRows: string[][] = [],
  options?: ExcelExportOptions
): void {
  const sheetData: (string | number)[][] = [];

  for (const meta of metaRows) {
    if (meta.length) {
      sheetData.push(meta);
    }
  }
  if (metaRows.length) {
    sheetData.push([]);
  }

  sheetData.push(headers);
  sheetData.push(...rows);

  const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
  const numericCols = options?.numericColumnIndexes ?? [];

  if (numericCols.length && rows.length) {
    let headerRowIndex = 0;
    for (const meta of metaRows) {
      if (meta.length) headerRowIndex++;
    }
    if (metaRows.length) headerRowIndex++;
    const firstDataRow = headerRowIndex + 1;
    for (let r = 0; r < rows.length; r++) {
      for (const col of numericCols) {
        const cellRef = XLSX.utils.encode_cell({ r: firstDataRow + r, c: col });
        const raw = rows[r][col];
        const num = typeof raw === 'number' ? raw : Number(String(raw).replace(/\./g, '').replace(',', '.'));
        if (!Number.isNaN(num) && worksheet[cellRef]) {
          worksheet[cellRef].t = 'n';
          worksheet[cellRef].v = num;
          worksheet[cellRef].z = '#,##0.00';
        }
      }
    }
  }

  const colWidths = headers.map((h, colIndex) => {
    const maxLen = Math.max(
      h.length,
      ...rows.map((row) => String(row[colIndex] ?? '').length)
    );
    return { wch: Math.min(Math.max(maxLen + 2, 10), 48) };
  });
  worksheet['!cols'] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, options?.sheetName || 'Relatorio');

  const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const safeName = fileName.replace(/\.(csv|xls|xlsx)$/i, '');
  const downloadName = `${safeName}.xlsx`;

  try {
    saveAs(blob, downloadName);
  } catch {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = downloadName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 500);
  }
}
